var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.6v-3.2l-4-.8c-.2-1-.6-1.8-1.2-2.8L27 7.3l-2.4-2.4-3.4 2.2c-.8-.6-1.8-1-2.6-1.2l-1-4h-3.2l-1 4c-.8.2-1.8.6-2.6 1.2L7.2 5 5 7.2l2.2 3.4c-.6 1-1 2-1.2 2.8l-4 1v3.4l4 .8c.2 1 .6 1.8 1.2 2.8L5 24.8l2.4 2.4 3.4-2.2c.8.4 1.8 1 2.8 1.2l.8 4h3.4l.8-4c1-.2 1.8-.6 2.8-1.2l3.4 2.2 2.4-2.4-2.2-3.4c.4-.8 1-1.8 1.2-2.8zm-14 3c-2.6 0-4.6-2-4.6-4.6s2-4.6 4.6-4.6 4.6 2 4.6 4.6-2 4.6-4.6 4.6"
  })));
};
export default SvgGear;